import React, { useState } from 'react'
import InputCustom from '../../../../components/elements/InputCustom'
import TextAreaCustom from '../../../../components/elements/TextAreaCustom'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'

function ProductDescription({langLocal, fields, setFields }) {
    //const [fields, setFields] = useState([{ name: '', description: '' }])
    const { translate } = AbstructLang()
    const handleFieldChange = (index, field, value) => {
        const newFields = [...fields]
        newFields[index][field] = value
        setFields(newFields)
    }

    const addField = () => {
        const newFields = [...fields, { name: '', description: '' }]
        setFields(newFields)
    }

    const removeField = (index) => {
        const newFields = [...fields]
        newFields.splice(index, 1)
        setFields(newFields)
    }

    return (
        <>
            <p className={`basic-pro ${langLocal === 'ar'? "textAlignRight": ""}`} style={{ marginBottom: "7px" }} >{translate('material_descriptions')}</p>
            {fields.map((field, index) => (
                <div key={index} className='d-flex'>
                    
                        <InputCustom
                            label='name'
                            iconType='pencil'
                            type='text'
                            value1={field.name}
                            onChange={(e) => handleFieldChange(index, 'name', e.target.value)}
                        />
                    
                    <div className='one-text-area w-70'>
                        <TextAreaCustom
                            label='description'
                            value={field.description}
                            onChange={(e) => handleFieldChange(index, 'description', e.target.value)}
                            nameClass='textarea-gen'
                        />
                    </div>
                    {
                        index === 0 && (
                            <i className='fa fa-plus plus-arr' onClick={addField} ></i>
                        )
                    }
                    {
                        index > 0 && (
                            <i className='fa fa-minus minus-arr' onClick={() => removeField(index)} ></i>
                        )
                    }
                </div>
            ))}
        </>
    )
}

export default ProductDescription